import { useAppContext } from './AppContext'

export const useGetQuoteConfig = () => {
  const { blogFeatureConfigData } = useAppContext();
  const subscriptionItem = blogFeatureConfigData?.find((item: any) => item?.feature?.feature_key === "disable_blog_get_quote")
  let config = {}
  if (subscriptionItem && subscriptionItem?.feature?.configuration?.value?.length) {
    subscriptionItem?.feature?.configuration?.value?.forEach((item: any) => {
      config = { ...config, [item.key]: item.value }
    })
  }
  return config
}